export default function HowItWorks() {
  const steps = [
    {
      icon: "ri-shield-check-line",
      color: "bg-green-50 text-green-600",
      title: "Factory Gets Verified",
      desc: "Manufacturers apply and get verified by our team. Verified badge builds instant buyer trust.",
    },
    {
      icon: "ri-upload-cloud-2-line",
      color: "bg-orange-50 text-orange-600",
      title: "Upload Products",
      desc: "Verified factories upload products with photos, pricing, and inventory. Goes live instantly.",
    },
    {
      icon: "ri-user-star-line",
      color: "bg-purple-50 text-purple-600",
      title: "Influencers Promote",
      desc: "TikTok, YouTube & Twitter stars share products with their audience and earn commission.",
    },
    {
      icon: "ri-shopping-cart-2-line",
      color: "bg-blue-50 text-blue-600",
      title: "Customer Orders",
      desc: "Buyers place orders directly. Secure checkout with multiple payment options.",
    },
    {
      icon: "ri-truck-line",
      color: "bg-yellow-50 text-yellow-600",
      title: "Seller Ships & Tracks",
      desc: "Seller enters tracking number. Customer gets instant email & SMS notification.",
    },
    {
      icon: "ri-star-smile-line",
      color: "bg-red-50 text-red-600",
      title: "Review & Repeat",
      desc: "Customer reviews the product. Community grows stronger with every transaction.",
    },
  ];

  return (
    <section className="py-16 px-6 md:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">How StarBookPrime Works</h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            From factory floor to your front door — a seamless experience for everyone on the platform.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <div key={step.title} className="flex gap-4 p-5 rounded-xl border border-gray-100 hover:border-orange-200 transition-colors">
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${step.color}`}>
                <i className={`${step.icon} text-xl`} />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-bold text-gray-400">STEP {i + 1}</span>
                </div>
                <h3 className="text-sm font-bold text-gray-900 mb-1">{step.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
